import { useMemo } from 'react'

export type InputRangeItemProps = {
  item: {
    value: number
    label: string
  }
  active: boolean
  isFirst: boolean
  isLast: boolean
  onClick: (value: number) => void
}

export default function InputRangeItem({ item, active, isFirst, isLast, onClick }: InputRangeItemProps) {
  const positionClassName = useMemo(() => {
    if (isFirst) {
      return '-left-10 md:left-1/2 md:-translate-x-1/2'
    }
    if (isLast) {
      return '-right-10 md:right-1/2 md:translate-x-1/2'
    }
    return 'left-1/2 -translate-x-1/2'
  }, [isFirst, isLast])

  return (
    <button
      className={`InputRange__Bullet group relative w-32 md:w-160 aspect-square flex items-center justify-center ${
        active ? 'active' : ''
      } rounded-full outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-scarlet`}
      onClick={() => onClick(item.value)}
      type='button'
    >
      <span className='block w-16 h-16 rounded-full bg-coral' />
      <span className='max-md:hidden text-body-s flex items-center absolute top-1/2 mt-20 left-1/2 -translate-x-1/2 whitespace-nowrap px-16 min-h-40 bg-dark-cream rounded-8 transition-all duration-500 ease-out-quad group-[.active]:opacity-0 group-[.active]:translate-y-[60px]'>
        {item.label}
      </span>
      <span
        className={`text-body-s flex md:hidden items-center absolute top-1/2 mt-20 ${positionClassName} whitespace-nowrap px-12 min-h-[36px] bg-peach rounded-8 transition-all duration-500 ease-out-quad opacity-0 group-[.active]:opacity-100 group-[.active]:translate-y-[60px]`}
      >
        {item.label}
      </span>
    </button>
  )
}
